export const MONTHLY_SUMMARY_API_ERROR = "MONTHLY_SUMMARY_API_ERROR";
export const MONTHLY_SUMMARY_SET_ACTIVE_CHART_TYPE = "MONTHLY_SUMMARY_SET_ACTIVE_CHART_TYPE";
export const FETCH_MONTHLY_SUMMARY_PREVIOUS_DATA_SUCCESS = "FETCH_MONTHLY_SUMMARY_PREVIOUS_DATA_SUCCESS";
export const FETCH_MONTHLY_SUMMARY_NEXT_DATA_SUCCESS = "FETCH_MONTHLY_SUMMARY_NEXT_DATA_SUCCESS";
export const MONTHLY_SUMMARY_UPDATE_ACTIVE_INDEX = "MONTHLY_SUMMARY_UPDATE_ACTIVE_INDEX";
export const MONTHLY_SUMMARY_UPDATE_ACTIVE_MODE = "MONTHLY_SUMMARY_UPDATE_ACTIVE_MODE";
export const FETCHING_MONTHLY_SUMMARY_DATA = "FETCHING_MONTHLY_SUMMARY_DATA";
export const MONTHLY_SUMMARY_DATA_RESET = "MONTHLY_SUMMARY_DATA_RESET";

export function apiError() {
  return {
      type: MONTHLY_SUMMARY_API_ERROR
  }
}
export function updateActiveChartType(payload){
    return{
        type: MONTHLY_SUMMARY_SET_ACTIVE_CHART_TYPE,
        payload: payload
    }
}

export function fetchMonthlySummaryPreviousDataSuccess(payload){
    return{
        type : FETCH_MONTHLY_SUMMARY_PREVIOUS_DATA_SUCCESS,
        payload: payload
    }
}

export function fetchMonthlySummaryNextDataSuccess(payload){
    return{
        type : FETCH_MONTHLY_SUMMARY_NEXT_DATA_SUCCESS,
        payload: payload
    }
}

export function updateActiveIndex(changeOffset){
    return{
        type : MONTHLY_SUMMARY_UPDATE_ACTIVE_INDEX,
        payload : changeOffset
    }
}

export function updateActiveMode(mode){
    return{
        type : MONTHLY_SUMMARY_UPDATE_ACTIVE_MODE,
        payload : mode
    }
}

export function fetchMonthlySummaryDataFailed(payload){
    return{
        type : MONTHLY_SUMMARY_API_ERROR,
        payload : payload
    }
}

export function fetchingMonthlySummaryData(){
    return{
        type: FETCHING_MONTHLY_SUMMARY_DATA
    }
}

export function resetMonthlySummaryData(){
    return {
        type: MONTHLY_SUMMARY_DATA_RESET
    }
}   